import { all, call, put, takeLatest } from 'redux-saga/effects';
import qs from 'qs';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import {
  fetchConversationByEntity,
  loadMoreConversationsByEntity,
} from '../routines/conversationRoutines';
import { convertFilterToVfl } from '../../common/util/velarisFilterLanguageUtils';
import { GLOBAL_DEFAULT_PAGE_SIZE } from '../../common/constants/CommonConstants';
import { MAX_CONVERSATION_LIMIT_ACTIVITYFEED } from '../../common/constants/conversationConstants';

export function* fetchConversationSaga({ payload }) {
  const { level, entityId, filters, query, lastModifiedDate, pageLimit } =
    payload;
  try {
    const convertedFilters = convertFilterToVfl(filters);
    const params = {};
    if (convertedFilters) params.filters = convertedFilters;

    if (query) params.query = query;

    params.lastModifiedDate = lastModifiedDate || new Date();
    params.pageLimit = pageLimit || MAX_CONVERSATION_LIMIT_ACTIVITYFEED;
    let URL = `${envConfig.APIG_URL}conversation/v2/threads?entityLevel=${level}&entityId=${entityId}`;
    if (Object.keys(params).length > 0) {
      URL = `${URL}&${qs.stringify(params)}`;
    }
    const response = yield call(request, URL);
    yield put(fetchConversationByEntity.success(response.data));
  } catch (error) {
    yield put(fetchConversationByEntity.failure({ error }));
  } finally {
    yield put(fetchConversationByEntity.fulfill());
  }
}

export function* loadMoreConversationsByEntitySaga({ payload }) {
  const { level, entityId, filters, query, lastModifiedDate } = payload;
  try {
    const convertedFilters = convertFilterToVfl(filters);
    const params = {};
    if (convertedFilters) params.filters = convertedFilters;

    if (query) params.query = query;

    params.lastModifiedDate = lastModifiedDate || new Date();
    params.pageLimit = GLOBAL_DEFAULT_PAGE_SIZE;
    let URL = `${envConfig.APIG_URL}conversation/v2/threads?entityLevel=${level}&entityId=${entityId}`;
    if (Object.keys(params).length > 0) {
      URL = `${URL}&${qs.stringify(params)}`;
    }
    const response = yield call(request, URL);
    yield put(loadMoreConversationsByEntity.success(response.data));
  } catch (error) {
    yield put(loadMoreConversationsByEntity.failure({ error }));
  } finally {
    yield put(loadMoreConversationsByEntity.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchConversationByEntity.TRIGGER, fetchConversationSaga),
    takeLatest(
      loadMoreConversationsByEntity.TRIGGER,
      loadMoreConversationsByEntitySaga
    ),
  ]);
}
